import { Container } from '@/components';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import BiCustomerView from './BiCustomerView';
import UploadFile from './UploadFile'; // Import the new component

const options = ['Add  Edit Bi Customer', 'Upload File'];

const Components = {
  'Add  Edit Bi Customer': () => <BiCustomerView />,
  'Upload File': () => <UploadFile />, // Use the new component
};

const BiCustomer = () => {
  const [selectedOption, setSelectedOption] = useState('Add  Edit Bi Customer'); // Fix initial state
  const SelectedComponent = Components[selectedOption];

  return (
    <Container title="Bi Customer">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className=" mx-10 p-8 bg-white shadow-lg rounded-xl border border-gray-200 my-10"
      >
        <div className="flex border-b mb-6">
          {options.map((option) => (
            <motion.div
              key={option}
              onClick={() => setSelectedOption(option)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={`cursor-pointer px-6 py-3 text-md font-semibold transition duration-300 ${selectedOption === option ? 'border-b-4 border-blue-700 text-blue-700' : 'text-gray-500 hover:text-gray-700'}`}
            >
              {option}
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="p-6 border rounded-lg bg-gray-50 shadow-sm"
        >
          <SelectedComponent />
        </motion.div>
      </motion.div>
    </Container>
  );
};

export default BiCustomer;
